<template>
   <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="text-body-1">
          Translation Data Upload Status
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-divider></v-divider>
        <div class="row">
          <div class="col">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width:300px" class="text-left">Title</th>
                    <th style="width:200px" class="text-left">Publisher Name</th>
                    
                    <th style="width: 200px">ISBN</th>
                    <th class="text-left">Message</th>
                    <!-- <th class="text-left">StartTime</th> -->
                    <!-- <th class="text-left">EndTime</th> -->
                    <th style="width:100px" class="text-left">Is Success</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list" :key="item.id" >
                    <td>{{ item.Title }}</td>
                    <td>{{ item.PublisherName }}</td>
                    <td>{{ item.ISBN }}</td>
                    <td>{{ item.Message }}</td>
                    <!-- <td>{{ item.StartTime | formatTime }}</td> -->
                    <!-- <td>{{ item.EndTime | formatTime}}</td> -->
                    <td class="text-center">
                       <v-icon v-show="item.isSuccess">mdi-check</v-icon>
                       <v-icon v-show="item.isSuccess == false">mdi-close</v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel" v-if="!options.noconfirm"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  name: 'UploadingStatus',
  computed: {
    // orderedList() {
    //   return this.list;
    // },
  },
  created() {
    
  },
  methods: {
    open(list) {
        this.dialog = true;
        this.list = list;
    },
    cancel() {
        this.dialog = false;
        this.list = [];
    },
  },
  props: {
  },
  computed: {
  },
  watch: {
    notify() {
    },
  },
  data() {
    return {
      list: [],
      dialog: false,
      options: {
        color: "primary",
        width: 1200,
        zIndex: 200,
        noconfirm: false,
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UploadingStatus.vue